export const radiusByMedia = {
  mobile: 150,
  desktop: 200,
};
